import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={16 * (props.wx ?? 1)}
    height={28 * (props.hx ?? 1)}
    viewBox="0 0 16 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2034_62"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="28"
      fill="black"
    >
      <rect fill="white" width="16" height="28" />
      <path d="M8.00023 26.3485C6.80135 26.3485 3.68362 28.0685 1.88283 25.9192C0.439759 24.1968 0.972755 20.0548 2.00719 17.2677C2.39195 16.2305 2.41622 15.2438 2.4 14.1248C2.32431 8.807 0.870484 1.50247 2.00719 1.5C3.14389 1.49753 5.85972 13.3511 7.99977 14.1248C8.87246 14.44 11 10.5 11.5 8C12 5.5 12.3081 1 13 1C13.6919 1 13.9928 5.50001 13.9928 6.5C13.9928 7.49999 13.643 11.7456 13.6919 14.1248C13.7148 15.2438 13.6081 16.231 13.9928 17.2677C15.0272 20.0553 15.5602 24.1973 14.1172 25.9192C12.3164 28.0685 9.19911 26.3485 8.00023 26.3485Z" />
    </mask>
    <path
      d="M8.00023 26.3485C6.80135 26.3485 3.68362 28.0685 1.88283 25.9192C0.439759 24.1968 0.972755 20.0548 2.00719 17.2677C2.39195 16.2305 2.41622 15.2438 2.4 14.1248C2.32431 8.807 0.870484 1.50247 2.00719 1.5C3.14389 1.49753 5.85972 13.3511 7.99977 14.1248C8.87246 14.44 11 10.5 11.5 8C12 5.5 12.3081 1 13 1C13.6919 1 13.9928 5.50001 13.9928 6.5C13.9928 7.49999 13.643 11.7456 13.6919 14.1248C13.7148 15.2438 13.6081 16.231 13.9928 17.2677C15.0272 20.0553 15.5602 24.1973 14.1172 25.9192C12.3164 28.0685 9.19911 26.3485 8.00023 26.3485Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.00023 26.3485C6.80135 26.3485 3.68362 28.0685 1.88283 25.9192C0.439759 24.1968 0.972755 20.0548 2.00719 17.2677C2.39195 16.2305 2.41622 15.2438 2.4 14.1248C2.32431 8.807 0.870484 1.50247 2.00719 1.5C3.14389 1.49753 5.85972 13.3511 7.99977 14.1248C8.87246 14.44 11 10.5 11.5 8C12 5.5 12.3081 1 13 1C13.6919 1 13.9928 5.50001 13.9928 6.5C13.9928 7.49999 13.643 11.7456 13.6919 14.1248C13.7148 15.2438 13.6081 16.231 13.9928 17.2677C15.0272 20.0553 15.5602 24.1973 14.1172 25.9192C12.3164 28.0685 9.19911 26.3485 8.00023 26.3485Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2034_62)"
    />
  </svg>
);
export default SvgNormal;
